  // should be synced villoid-nosto <-> villoid-shopify-theme-2023
  const customOrderSizes = [
    'XXS',
    'XXS/XS',
    'XXS/S',
    'XS',
    'XS/S',
    'XS/32',
    'S',
    'S/30',
    'S/32',
    'S/M',
    'M',
    'M/32',
    'M/L',
    'L',
    'L/32',
    'L/XL',
    'XL',
    'XL/XXL',
    'XXL',
    '0',
    '1',
    '2',
    '4',
    '5',
    '6',
    '7',
    '7,5',
    '8',
    '9',
    '10',
    '12',
    '31',
    '32',
    '32/34',
    '34',
    '34L',
    '34/L32',
    '35',
    '35.5',
    '35/36',
    '35/38',
    '36',
    '36 ⅓',
    '36,5',
    '36.5',
    '36/37',
    '36 ⅔',
    '36L',
    '36/38',
    '36/L32',
    '37',
    '37 ⅓',
    '37,5',
    '37.5',
    '37 ⅔',
    '37/38',
    '37/39',
    '38',
    '38 ⅓',
    '38,5',
    '38.5',
    '38 ⅔',
    '38L',
    '38/L32',
    '39',
    '39 ⅓',
    '39,5',
    '39.5',
    '39 ⅔',
    '39/40',
    '39/41',
    '39-41',
    '39/42',
    '40',
    '40,5',
    '40.5',
    '40/41',
    '40 ⅔',
    '40L',
    '40/L32',
    '41',
    '41 ⅓',
    '41,5',
    '41.5',
    '41/42',
    '41/43',
    '41/44',
    '42',
    '42,5',
    '42.5',
    '42 ⅓',
    '42/43',
    '42/44',
    '42/45',
    '42L',
    '42/L32',
    '43',
    '43 ⅓',
    '43,5',
    '43.5',
    '43/44',
    '43/45',
    '43/46',
    '44',
    '44.5',
    '44 ⅔',
    '44L',
    '44/L32',
    '44/W32',
    '44/45',
    '44/46',
    '44/47',
    '45',
    '45.5',
    '45/46',
    '45/47',
    '45/48',
    '46',
    '46,5',
    '46/47',
    '46/48',
    '47',
    '47,5',
    '47/48',
    '48',
    '49',
    '50',
    '51',
    '52',
    '53',
    '54',
    '55',
    '56',
    '57',
    '58',
    '59',
    '60',
    '61',
    '62',
    '70',
    '75',
    '80',
    '85',
    '90',
    '95',
    '105',
    'Høyre',
    'One Size',
    'One size',
    'Venstre',
    'W24',
    'W24/L30',
    'W24/L32',
    'W24/L34',
    'W24/L36',
    'W25',
    'W25/L30',
    'W25/L32',
    'W25/L34',
    'W25/L36',
    'W26',
    'W26/L30',
    'W26/L32',
    'W26/L34',
    'W26/L36',
    'W27',
    'W27/L30',
    'W27/L32',
    'W27/L34',
    'W27/L36',
    'W28',
    'W28/L30',
    'W28/L32',
    'W28/L34',
    'W28/L36',
    'W29',
    'W29/L30',
    'W29/L32',
    'W29/L34',
    'W29/L36',
    'W30',
    'W30/L30',
    'W30/L32',
    'W30/L34',
    'W30/L36',
    'W31',
    'W31/L30',
    'W31/L32',
    'W31/L34',
    'W31/L36',
    'W32',
    'W32/L30',
    'W32/L32',
    'W32/L34',
    'W32/L36',
    'W33',
    'W33/L30',
    'W33/L32',
    'W33/L34',
    'W33/L36',
    'W34',
    'W34/L30',
    'W34/L32',
    'W34/L34',
  ].map(s => s.toLowerCase());
  /* Custom Dropdown JS logic */
  const DropDownHandler = (optionName) => {
    const visibilityClass = 'visually-hidden';
    const triggerButton = document.getElementById('custom-variant-select-' + optionName);
    const dropdown = document.getElementById('select-' + optionName);
    if (!dropdown) return;
    const backdrop = document.getElementById('select-backdrop-' + optionName);
    const isDropdownVisible = () => dropdown.classList.contains(visibilityClass);

    // hide dropdown on search
    const hideDropdown = () => {
      triggerButton.classList.remove('active');
      backdrop.classList.add(visibilityClass);
      dropdown.classList.add(visibilityClass);
    };
    document.getElementById('boost-pfs-search-box-desktop')?.addEventListener('focus', hideDropdown);
    document.getElementById('boost-pfs-search-box-mobile')?.addEventListener('focus', hideDropdown);

    const labels = dropdown.querySelectorAll('.variant-input');
    const sortAlphanumerical = (accessFunc) => (a, b) => parseInt(accessFunc(a)) < parseInt(accessFunc(b)) ? -1 : 1;
    const whitelistedSizes = [...customOrderSizes];
    const sortWhiteListedSizes = (accessFunc) => (a, b) => {
      const aIndex = whitelistedSizes.indexOf(accessFunc(a).toLowerCase());
      const bIndex = whitelistedSizes.indexOf(accessFunc(b).toLowerCase());
      return aIndex < bIndex ? -1 : 1;
    };
    const getLabelValue = (element) => element.getAttribute('data-value');
    const values = [...labels].map((label) => getLabelValue(label));
    const allValuesAreNumerical = values.every((value) => !isNaN(parseInt(value)));
    const allValuesAreWhitelistedSizes = values.every((value) => whitelistedSizes.indexOf(value.toLowerCase()) + 1);
    let sortingAlgorithm = null;
    if (allValuesAreNumerical) {
      sortingAlgorithm = sortAlphanumerical;
    } else if (allValuesAreWhitelistedSizes) {
      sortingAlgorithm = sortWhiteListedSizes;
    } else {
      // console.log("couldn't detect sorting algorithm, keeping default order", {
      //   labels,
      //   values,
      // });
    }

    try {
      if (sortingAlgorithm) {
        const sortedLabels = [...labels].sort(sortingAlgorithm(getLabelValue));
        labels.forEach((label) => label.remove());
        sortedLabels.forEach((sortedLabel) => dropdown.appendChild(sortedLabel));
      }
    } catch (e) {
      console.error(e);
    }

    triggerButton?.addEventListener('click', (e) => {
      e.preventDefault();
      if (isDropdownVisible()) {
        triggerButton.classList.add('active');
        backdrop.classList.remove(visibilityClass);
        dropdown.classList.remove(visibilityClass);
      } else {
        hideDropdown();
      }
      const target = e.target.closest('.variant-input');
      if (target && target.getAttribute('data-value')) {
        const value = target.getAttribute('data-value');
        const select = document.querySelector('select.select-' + optionName);
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        triggerButton.querySelector('.trigger-button span.text').innerText = value;
        triggerButton.classList.add('has-value');

        const addToCartWrapper = document.querySelector('[data-num-available-variants]');
        if (addToCartWrapper) {
          addToCartWrapper.removeAttribute('data-num-available-variants');
          if (window?.dropdownTriggeredFromAddToCart) {
            document.querySelector('[data-add-to-cart]').click();
          } else if (window?.dropdownTriggeredFromVippsBtn) {
            window.dropdownTriggeredFromVippsBtn = false;
            setTimeout(() => {
              // Re-fire the Vipps app button now that a size is chosen. The size-flow
              // interceptor (snippets/vipps-express-size-flow.liquid) passes this click
              // through because data-num-available-variants was just removed above, and the
              // Vipps button-script reads the chosen variant from select[name="id"].
              document.querySelector('.vipps-express-container .vipps-btn:not([disabled])')?.click();
            }, 300);
          }
        }
      }
    });
  };
  [...document.querySelectorAll('.variant-input-wrap')].map((el) => {
    const optionName = el.getAttribute('data-option-name');
    DropDownHandler(optionName);
  });
